import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as assetTypes from '../components/AssetClass/assetTypes';
import * as applicationActions from '../actions/applicationActions';
import * as registrationActions from '../actions/registrationActions';
import * as accountTypeActions from '../actions/accountTypeActions';
import * as assetClassActions from '../actions/assetClassActions';
import * as identityActions from '../actions/identityActions';
import * as addressActions from '../actions/addressActions';
import * as tradingProfileActions from '../actions/tradingProfileActions';
import * as userActions from '../actions/userActions';
import * as financialActions from '../actions/financialActions';
import * as salesRepsActions from '../actions/salesRepsActions';
import * as redirectionActions from '../actions/redirectionActions';
import * as RouteNavigator from './RouteNavigator';
import * as sessionStorageHelper from '../lib/sessionStorageHelper';
import * as storageKeys from '../actions/storageKeys';
import ApprovalStatus from '../components/ApprovalStatus/ApprovalStatus';
import signOutUrl from '../lib/signOutUrl';
import Config from '../Config';
import hasAccountsOrFake from '../lib/containerHelpers/approvalStatus/approvalStatusHelper';
import pushToAnalytics from '../lib/analytics';
import { aopAnalyticsSteps } from '../lib/analyticsHelper';
import ApprovalEntity from '../components/ApprovalEntity/ApprovalEntity';
import hasFormstackHandoff from '../lib/formstack/hasFormstackHandoff';
import * as amplitude from '../lib/amplitude';
import { getCookie } from '../lib/cookieManager';
import { setOptionsStrategyLevel } from './AccountTypeFormContainerHelper';
import { mapSalesRepsToOptions } from './RegistrationCredentialsFormContainer';
import { filterAppSalesReps } from './salesRepsHelpers';

const config = new Config();

function redirectToDepositFunds() {
  RouteNavigator.push('/deposit-funds');
}

const redirectToAccountType = () => {
  RouteNavigator.push('/account-type');
};

const redirectToTsLearn = () => {
  window.location = config.tradestationLearnUrl;
};

const handleTrackEvent = (props, accountNumbersReady, inlineFundingReady) => {
  const fdcnId = props.registration ? props.registration.fdcnId : null;
  const googleClientId = getCookie('ga_cid');
  let eventProperties = {};
  const tseuChangesEnabled = config.tseuChangesEnabled;
  const isTseu = tseuChangesEnabled && props.application && props.application.isTSEU;
  const rep = props.salesReps.find(r => r.key === props.registration.hearAboutUsSalesRep);
  const offerSession = sessionStorageHelper.getSessionStorage(storageKeys.PROMO_CODE_SESSION);
  const optionsLevel = props.assetClass && props.assetClass.optionsStrategies
    && props.assetClass.optionsStrategies.length > 0 ?
      setOptionsStrategyLevel(props.assetClass.optionsStrategies) : null;
  const eligibleOptionsLevel = localStorage && localStorage.getItem ?
    localStorage.getItem(`eligible-options-level-${props.applicationId}`) : null;
  if (props.registration && props.accountType && props.assetClass) {
    eventProperties = {
      application_id: props.applicationId,
      tradestation_entity: isTseu ? 'tseu' : 'tss',
      relationship_status: props.registration.isExistingCustomer ? 'returning' : 'new',
      account_type: amplitude.mapAccountType2(props.accountType),
      equities_account: props.accountType.assetTypes.includes('equities'),
      account_format: props.assetClass.marginAccount ? 'margin' : 'cash',
      futures_account: props.accountType.assetTypes.includes('futures'),
      futures_options_account: props.assetClass.tradeFuturesOptions,
      account_numbers_ready: accountNumbersReady,
      inline_funding_ready: inlineFundingReady,
    };
  }
  if (props.assetClass && props.assetClass.tradeStockOptions) eventProperties.equities_account_options_trading = props.assetClass.tradeStockOptions;
  if (optionsLevel) eventProperties.account_options_level = optionsLevel;
  if (eligibleOptionsLevel) eventProperties.eligible_options_level = eligibleOptionsLevel;
  if (offerSession) eventProperties.promo_code = offerSession;
  if (rep) eventProperties.sales_rep = rep.title;
  if (googleClientId) eventProperties.google_client_id = googleClientId;
  amplitude.trackEvent('aop_completed', eventProperties, fdcnId);
};

export class ApprovalStatusContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = { isLeaving: false };
    this.finishApplication = this.finishApplication.bind(this);
    this.startNewApplication = this.startNewApplication.bind(this);
  }

  componentWillMount() {
    const { hasCarmaAccounts, hasFakeOrNoMoreBusiness, hasBypassedCarmaAccounts } = this.props;
    let accountNumbersReady = false;
    let inlineFundingReady = false;
    const tseuChangesEnabled = config.tseuChangesEnabled;
    const isTseu = tseuChangesEnabled && this.props.application && this.props.application.isTSEU;
    if (hasCarmaAccounts && !hasFakeOrNoMoreBusiness && !hasBypassedCarmaAccounts && !isTseu) {
      redirectToDepositFunds();
      accountNumbersReady = true;
      inlineFundingReady = true;
    }
    handleTrackEvent(this.props, accountNumbersReady, inlineFundingReady);
  }

  componentDidMount() {
    const {
      actions,
      applicationId,
      authToken,
      registration,
      accountType,
      assetClass,
      identity,
      address,
      tradingProfile,
      financial,
      salesReps,
    } = this.props;

    if (salesReps.length === 0) actions.fetchSalesReps();
    if (!registration || !accountType || !assetClass || !identity || !address || !tradingProfile || !financial) {
      Promise.all([
        actions.fetchRegistration(applicationId, authToken),
        actions.fetchAccountType(applicationId, authToken),
        actions.fetchAssetClass(applicationId, authToken),
        actions.fetchIdentity(applicationId, authToken),
        actions.fetchAddress(applicationId, authToken),
        actions.fetchTradingProfile(applicationId, authToken),
        actions.fetchFinancial(applicationId, authToken),
      ]).then(() => {
        pushToAnalytics(
          aopAnalyticsSteps.THANK_YOU.name,
          { applicationId,
            authToken,
            registration,
            accountType,
            assetClass,
            address,
            identity,
            tradingProfile,
            financial,
          },
        );
      });
    } else {
      pushToAnalytics(
        aopAnalyticsSteps.THANK_YOU.name,
        {
          applicationId,
          authToken,
          registration,
          accountType,
          assetClass,
          address,
          identity,
          tradingProfile,
          financial,
        },
      );
    }
  }

  startNewApplication() {
    if (this.state.isLeaving) return;
    const { authToken, userId } = this.props;
    this.props.actions.setBusinessAppRedirection(true);
    this.props.actions.setTseuFlagRedirection(config.tseuChangesEnabled
      && this.props.application
      && this.props.application.isTSEU);
    this.props.actions.startApplication(userId, authToken)
      .then(redirectToAccountType)
      .catch(() => {
        this.props.actions.userLogout(this.props.authToken)
        .then(() => {
          window.location = signOutUrl('/logout.html?manual');
        });
      });
  }

  // TS Learn takes a moment to load, and this page stays on screen until it has. userLogout would
  // reset the store underneath it, falling back to the individual ApprovalStatus page for that
  // wait -- which read as a second thank-you page -- so the store is only reset as the page goes.
  // Its buttons stay live for that wait too, so both are disabled once the applicant is leaving.
  finishApplication() {
    if (this.state.isLeaving) return Promise.resolve();
    this.setState({ isLeaving: true });
    return this.props.actions.userLogoutBeforeLeaving(this.props.authToken).then(redirectToTsLearn);
  }

  render() {
    const accountType = this.props && this.props.accountType && this.props.accountType.accountType;
    const isBusinessAppRedirection = this.props &&
      this.props.redirectionInfo &&
      this.props.redirectionInfo.isBusinessAppRedirection;
    const isBusinessTrust = accountType && accountType.includes('entity');
    if (isBusinessTrust || isBusinessAppRedirection) {
      return (
        <ApprovalEntity
          {...this.props}
          isLeaving={this.state.isLeaving}
          startNewApplication={this.startNewApplication}
          finishApplication={this.finishApplication}
          salesReps={mapSalesRepsToOptions(filterAppSalesReps(this.props.salesReps, this.props.application))}
        />
      );
    }

    return (
      <ApprovalStatus {...this.props} />
    );
  }
}

ApprovalStatusContainer.propTypes = {
  actions: PropTypes.shape({
    fetchSalesReps: PropTypes.func.isRequired,
    fetchApplication: PropTypes.func.isRequired,
    fetchRegistration: PropTypes.func.isRequired,
    fetchAccountType: PropTypes.func.isRequired,
    fetchAssetClass: PropTypes.func.isRequired,
    fetchIdentity: PropTypes.func.isRequired,
    startApplication: PropTypes.func.isRequired,
    fetchAddress: PropTypes.func.isRequired,
    fetchTradingProfile: PropTypes.func.isRequired,
    fetchFinancial: PropTypes.func.isRequired,
    userLogout: PropTypes.func.isRequired,
    userLogoutBeforeLeaving: PropTypes.func.isRequired,
    setBusinessAppRedirection: PropTypes.func.isRequired,
    setTseuFlagRedirection: PropTypes.func.isRequired,
  }).isRequired,
  salesReps: PropTypes.arrayOf(PropTypes.shape()),
  hasCarmaAccounts: PropTypes.bool,
  hasFakeOrNoMoreBusiness: PropTypes.bool,
  hasBypassedCarmaAccounts: PropTypes.bool,
  applicationId: PropTypes.string,
  accountType: PropTypes.shape(),
  authToken: PropTypes.string.isRequired,
  application: PropTypes.shape(),
  registration: PropTypes.shape(),
  assetClass: PropTypes.shape(),
  identity: PropTypes.shape(),
  userId: PropTypes.number.isRequired,
  address: PropTypes.shape(),
  tradingProfile: PropTypes.shape(),
  financial: PropTypes.shape(),
  redirectionInfo: PropTypes.shape({
    isBusinessAppRedirection: PropTypes.bool,
    isTseu: PropTypes.bool,
  }),
};

export function mapStateToInitialValues(state) {
  let hearAboutUsSalesRep = '';
  let isExistingCustomer = false;


  const { hasCarmaAccounts, hasFakeOrNoMoreBusiness, hasBypassedCarmaAccounts } = hasAccountsOrFake(state.application);
  const salesRepSession = sessionStorageHelper.getSessionStorage(storageKeys.SALES_REP_SESSION);
  if (state.registration) {
    isExistingCustomer = state.registration.isExistingCustomer;
    hearAboutUsSalesRep = state.registration.hearAboutUsSalesRep;
  }
  let canTradeCrypto = false;
  if (state.accountType && state.accountType.assetTypes) {
    if (state.accountType.assetTypes.includes(assetTypes.ASSET_CLASS_TYPES_CRYPTO)) {
      const cryptoSelected = state.accountType.assetTypes.includes(assetTypes.ASSET_CLASS_TYPES_CRYPTO);
      canTradeCrypto = cryptoSelected;
    }
  }

  if (salesRepSession && isExistingCustomer && !hearAboutUsSalesRep) hearAboutUsSalesRep = salesRepSession;

  return {
    hearAboutUsSalesRep,
    hasCarmaAccounts,
    hasFakeOrNoMoreBusiness,
    hasBypassedCarmaAccounts,
    canTradeCrypto,
  };
}

export function mapStateToProps(state) {
  const initialValues = mapStateToInitialValues(state);

  return {
    hasCarmaAccounts: initialValues.hasCarmaAccounts,
    hasFakeOrNoMoreBusiness: initialValues.hasFakeOrNoMoreBusiness,
    hasBypassedCarmaAccounts: initialValues.hasBypassedCarmaAccounts,
    application: state.application,
    applicationId: state.applicationId,
    authToken: state.authToken,
    userId: state.userId,
    canTradeCrypto: !!initialValues.canTradeCrypto,
    registration: state.registration,
    accountType: state.accountType,
    assetClass: state.assetClass,
    identity: state.identity,
    address: state.address,
    tradingProfile: state.tradingProfile,
    financial: state.financial,
    redirectionInfo: state.redirectionInfo,
    salesReps: state.salesReps,
    // FR-006 — decides which set of instructions the entity finish screen gives. The same
    // persisted hand-off that chose the experience chooses the copy describing it.
    showEmbeddedExperience: hasFormstackHandoff(state),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(Object.assign({},
      applicationActions,
      registrationActions,
      accountTypeActions,
      assetClassActions,
      identityActions,
      addressActions,
      tradingProfileActions,
      userActions,
      financialActions,
      salesRepsActions,
      redirectionActions,
    ), dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ApprovalStatusContainer);
